import { MessageSquare } from "lucide-react";

import { useDialogs } from "@toolpad/core/useDialogs";

import { AppButton } from "@components/v2/AppButton";
import { ComentariosGeneralesDialog } from "@components/v2/ComentariosGeneralesDialog";

/** Trigger v2 del popover "Comentarios" de `CustomHeader.tsx` — abre `ComentariosGeneralesDialog` vía `useDialogs()`. */
export const ComentariosButton = () => {
    const dialogs = useDialogs();

    return (
        <AppButton
            tone="ghost"
            startIcon={<MessageSquare size={14} />}
            sx={{ height: 34, fontSize: "0.75rem" }}
            onClick={() => dialogs.open(ComentariosGeneralesDialog, {})}
        >
            Comentarios
        </AppButton>
    );
};
